import { getUrlParams, isIPhone } from '../../../utils';
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    // 标题是否全显示，默认一行省略截断
    // 改为标题不省略，全部显示
    fullView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const {
      abtest
    } = getUrlParams(location.href) || {};
    return {
      abtest: abtest || ''
    };
  },
  computed: {
    // 是否压缩空间
    compress() {
      return !!(this.abtest.includes('106308') || this.abtest.includes('106309'));
    },
    classList() {
      return {
        'title-line': true,
        'is-ios-title': isIPhone(),
        'hidden-style': !this.fullView,
        'panel-style': this.fullView,
        'space-compress': true
      };
    }
  }
};